import {pluralize} from "@pg-mono/string-utils";

export const offerPlural = pluralize(["ofertę", "oferty", "ofert"]);
export const offerPluralBase = pluralize(["oferta", "oferty", "ofert"]);
import {pluralize} from "@pg-mono/string-utils";

export const offerPlural = pluralize(["ofertę", "oferty", "ofert"]);
export const offerPluralBase = pluralize(["oferta", "oferty", "ofert"]);
